export const Forbidden = "Forbidden";
export const Unauthorized = "Unauthorized";
export const unknownDataAccessError = "Something bad happened";
export const multipleAccountForAnEmail = multipleAccountMessage();
export const passwordChangeSuccess = "Successfully changed Password.";
export const invalidLink = "It looks like you clicked on an invalid password reset link.";
export const wrongUsernameAndPassword = "Please enter a valid Username & Password"


function multipleAccountMessage() {
    let message = "There is more than one person associated with this email. Please ";
    if (window.ENV.SUPPORT_TELEPHONE_NUMBER) {
        message = message + "contact support on " + window.ENV.SUPPORT_TELEPHONE_NUMBER;
    }
    if (window.ENV.SUPPORT_EMAIL && !window.ENV.SUPPORT_TELEPHONE_NUMBER) {
        message = message + "email support on " + window.ENV.SUPPORT_EMAIL;
    }
    if (window.ENV.SUPPORT_EMAIL && window.ENV.SUPPORT_TELEPHONE_NUMBER) {
        message = message + " or email " + window.ENV.SUPPORT_EMAIL;
    }
    if (!window.ENV.SUPPORT_EMAIL && !window.ENV.SUPPORT_TELEPHONE_NUMBER) {
        message = message + "contact support";
    }
    message = message + ".";
    return message;
}